import { __rest } from "tslib";
import React from 'react';
import classname from 'classnames';
import styles from './main.module.scss';
const TabContentLayout = React.forwardRef((props, ref) => {
    const { children, className, component, style } = props, rest = __rest(props, ["children", "className", "component", "style"]);
    const componentProps = {
        className: classname([styles.mailTabContentLayoutWarpper, className || '']),
        children,
        ref,
    };
    return (React.createElement("div", Object.assign({ style: Object.assign({ width: '100%', height: 48 }, style) }, rest), React.createElement(component || 'div', componentProps)));
});
export default TabContentLayout;
